module.exports = __webpack_public_path__ + "img/email-action-settings.c1efb74e.svg";